import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { SITE, OG_IMAGE, META, DEFAULT_TITLE, DEFAULT_DESC, NOINDEX_PREFIXES, HOME_JSONLD } from "@/lib/seo";

export default function RouteSeo() {
  const { pathname } = useLocation();
  const key = pathname.startsWith("/legal") ? "/legal" : pathname;
  const meta = META[key];
  const noindex = NOINDEX_PREFIXES.some((p) => pathname.startsWith(p));
  const title = meta ? (meta.exactTitle ? meta.title : `${meta.title} | ZettaKeep`) : DEFAULT_TITLE;
  const description = meta?.description || DEFAULT_DESC;
  const canonical = SITE + (pathname === "/" ? "" : pathname);

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ZettaKeep" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {pathname === "/" && (
        <script type="application/ld+json">{JSON.stringify(HOME_JSONLD)}</script>
      )}
    </Helmet>
  );
}
